import { render } from "./SinistroAprovacaoDetalheView.vue?vue&type=template&id=7f5f12f9&scoped=true"
import script from "./SinistroAprovacaoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroAprovacaoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroAprovacaoDetalheView.vue?vue&type=style&index=0&id=7f5f12f9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5f12f9"]])

export default __exports__